(() => {
  if (customElements.get('speediance-product-menu')) return;
  customElements.define('speediance-product-menu', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.header = this.closest('header');
      if (!this.details || !this.header) return;
      this.setAttribute('data-ready', '');
      this.position = () => this.style.setProperty('--sp-menu-top', Math.max(0, this.header.getBoundingClientRect().bottom) + 'px');
      this.close = () => { clearTimeout(this.timer); this.details.open = false; this.summary.setAttribute('aria-expanded', 'false'); };
      this.show = () => {
        clearTimeout(this.timer);
        if (!matchMedia('(min-width:1024px)').matches) return;
        this.header.querySelectorAll('speediance-product-menu').forEach(menu => { if (menu !== this && menu.close) menu.close(); });
        this.header.querySelectorAll('details[is="details-dropdown"],details[is="details-mega"]').forEach(menu => { menu.open = false; });
        this.position(); this.details.open = true; this.summary.setAttribute('aria-expanded', 'true');
      };
      this.details.addEventListener('toggle', () => { this.position(); this.summary.setAttribute('aria-expanded', String(this.details.open)); }, options);
      this.summary.addEventListener('click', event => {
        event.preventDefault();
        const hoverClick = this.dataset.hover === 'true' && event.detail > 0 && event.pointerType !== 'touch' && matchMedia('(hover:hover) and (pointer:fine)').matches;
        if (hoverClick || !this.details.open) this.show(); else this.close();
      }, options);
      this.summary.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown') { event.preventDefault(); this.show(); this.querySelector('.sp-product-card')?.focus(); }
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.details.open) { event.preventDefault(); event.stopPropagation(); this.close(); this.summary.focus(); }
      }, options);
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse' && this.dataset.hover === 'true') this.show(); }, options);
      this.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse' && this.dataset.hover === 'true') this.timer = setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); }, 180);
      }, options);
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.close(); }, options);
      document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) this.close(); }, options);
      this.header.addEventListener('pointerover', event => {
        if (event.target.closest('.header__menu') && !this.contains(event.target)) this.close();
      }, options);
      window.addEventListener('scroll', () => { if (this.details.open) this.position(); }, {...options, passive:true});
      window.addEventListener('resize', () => { if (!matchMedia('(min-width:1024px)').matches) this.close(); this.position(); }, options);
      this.observer = new ResizeObserver(this.position); this.observer.observe(this.header); this.position();
      document.addEventListener('shopify:block:select', event => { if (this.contains(event.target)) this.show(); }, options);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); this.observer?.disconnect(); }
  });
})();
